import React from 'react';
import { StatusChipType } from '@utmost.co/utmost-design-system';
import { FieldPermission } from '../../../forms';
import { mapPolicyKeyToPermissionKey } from '../utils/useGetStatusType';
import { StyledPill, StyledDefaultPill, StyledIcon } from './Styles.css/PolicyLink.styles';
import { PermissionIcon } from '../PermissionIcon';

interface PermissionHelperProps {
  permission?: FieldPermission;
  resourceUid?: string;
  permissionKey: 'READ' | 'UPDATE';
  type?: StatusChipType | undefined;
}

export const PermissionPill: React.FC<React.PropsWithChildren<PermissionHelperProps>> = ({
  permission,
  permissionKey,
  type
}) => {
  const legacyKey = mapPolicyKeyToPermissionKey(permissionKey);

  const isPermissionTrue = !!permission?.[legacyKey as keyof FieldPermission];

  return (
    <>
      {permission?.[legacyKey as keyof FieldPermission] !== undefined ? (
        <StyledPill
          leftIcon={<StyledIcon size={16} name={isPermissionTrue ? 'check_circle' : 'block'} color={type} />}
          $type={type}
          $colorType={isPermissionTrue ? StatusChipType.GREEN : StatusChipType.RED}
          text={isPermissionTrue ? 'Permit' : 'Deny'}
        />
      ) : (
        <StyledDefaultPill
          leftIcon={<PermissionIcon type={permissionKey === 'UPDATE' ? 'WRITE' : permissionKey} />}
          $type={StatusChipType.GREY}
          text="Unknown"
        />
      )}
    </>
  );
};
